import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

	currentUser:any =null ;
	token:any =null;
	role :string;
	branch :string;
	email : any = "meghneel95@gmail.";
	username : any ;


	constructor(private router: Router) { }
	canActivate() {
		console.log('i am checking to see if you are logged in');
		if(localStorage.getItem('currentUser')) {
			console.log('inside canActivate 1st If');
			this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
			this.token = this.currentUser.token;
			this.role = this.currentUser.role;
			this.branch = this.currentUser.branch;
			this.username = this.currentUser.username;
		
			console.log(this.currentUser);
			console.log(this.token);
			console.log(this.role);
			console.log(this.branch);
			console.log(this.username);
			
			if (this.role === 'Admin'){
				console.log('inside canActivate 2nd If');
				return true;
			}
			else {
				swal(
					'Authentication Failure', 
					'You do not have necessary permission to access this Page!', 
					'warning'
				);
				return false;
				// this.router.navigate(['login']);
			}

		}

		else{
			swal(
				'Authentication Failure', 
				'You do not have necessary permission to access this Page!', 
				'warning'
			);
			return false;
			// this.router.navigate(['login']);
		}
		
	}

	canActivateChild() {
		console.log('checking child route access');
		return true;
	}


}


// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/auth/auth-guard.service.ts